import { render, staticRenderFns } from "./customize.vue?vue&type=template&id=d8c256b8&scoped=true"
import script from "./customize.vue?vue&type=script&lang=js"
export * from "./customize.vue?vue&type=script&lang=js"
import style0 from "./customize.vue?vue&type=style&index=0&id=d8c256b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c256b8",
  null
  
)

export default component.exports